import moment from 'moment';

export const dateToTitleFormat = (date, format) => {
    return date ? moment(date).format(format) : "TBD";
}